import { useEffect, useState } from "react";
import { Plus, Trash2, Tag } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";

export default function Discounts() {
  const [discounts, setDiscounts] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ code: "", type: "percentage", value: 10, min_order: 0, active: true });

  const load = () => api.get("/admin/discounts").then((r) => setDiscounts(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/admin/discounts", { ...form, value: parseFloat(form.value), min_order: parseFloat(form.min_order) }); toast.success("Discount saved"); setOpen(false); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { await api.delete(`/admin/discounts/${id}`); load(); };

  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <div><h1 className="font-display text-2xl font-bold tracking-tight">Discounts</h1><p className="text-sm text-zinc-500">Promo codes</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-discount-btn"><Plus size={15} className="mr-2" />New Code</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>New Discount Code</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Code</Label><Input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} placeholder="SUMMER25" data-testid="discount-code-input" /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Type</Label>
                  <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="percentage">Percentage %</SelectItem><SelectItem value="fixed">Fixed $</SelectItem></SelectContent>
                  </Select>
                </div>
                <div><Label>Value</Label><Input type="number" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} /></div>
              </div>
              <div><Label>Minimum order (USD)</Label><Input type="number" value={form.min_order} onChange={(e) => setForm({ ...form, min_order: e.target.value })} /></div>
            </div>
            <DialogFooter><Button onClick={create} data-testid="save-discount-btn">Create</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {discounts.map((d) => (
          <div key={d.id} className="bg-white border border-zinc-200 rounded-xl p-5 flex justify-between items-center" data-testid={`discount-${d.code}`}>
            <div className="flex items-center gap-3">
              <div className="bg-zinc-900 text-white w-10 h-10 rounded-lg flex items-center justify-center"><Tag size={16} /></div>
              <div><p className="font-mono font-bold">{d.code}</p>
                <p className="text-xs text-zinc-500">{d.type === "percentage" ? `${d.value}% off` : `$${d.value} off`}{d.min_order > 0 ? ` · min $${d.min_order}` : ""}</p></div>
            </div>
            <button onClick={() => del(d.id)} className="text-zinc-400 hover:text-red-600"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
